import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { IMAGES, DISHES, LUNCH_SPECIAL, MENU, SIDES, DRINKS } from "@/data/site";

const DEFAULT_CONTENT = {
  images: IMAGES,
  dishes: DISHES,
  lunchSpecial: LUNCH_SPECIAL,
  menu: MENU,
  sides: SIDES,
  drinks: DRINKS,
  catering: [],
};

const ContentContext = createContext({ content: DEFAULT_CONTENT, loading: true, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...DEFAULT_CONTENT, ...data });
    } catch (e) {
      setContent(DEFAULT_CONTENT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
